// removed by extract-text-webpack-plugin
module.exports = {"link":"Tab__link___3YEkG","active":"Tab__active___2P82i"};